/**
 * end.ts
 * Endノードの定義
 * フローの終了点を表す固定ノード（削除不可）
 */
import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { EndNodeView } from '../views/EndNode';

/**
 * Endノードの定義
 * - パレットには表示しない（固定で配置済み）
 * - 実行時は終了のログを出力するのみ
 */
export const endDefinition: NodeDefinition<'end'> = {
  label: 'End',
  showInPalette: false,     // 固定ノードなのでパレットに表示しない
  paletteColor: '',
  miniMapColor: '#ef4444',  // 赤色
  defaultData: { label: 'End' },
  view: EndNodeView,
  isTerminal: true,
  run: (_node, _ctx, log) => {
    log('[End] おわり');
  },
  help: {
    title: [t('End（おわり）')],
    description: [
      t('プログラムはここで'),
      r('終', 'お'),
      t('わりです。このカードに'),
      r('着', 'つ'),
      t('くと、プログラムが'),
      r('止', 'と'),
      t('まります。'),
    ],
  },
};
